import {lineLocal} from '@/api/apiPot'
export default {
  data() {
    return {};
  },
  methods: {
    /**跳转二级页面 */
    toSecPath(item) {
      lineLocal({ source_type: 1, source_info: item.name })
      this.$store.dispatch("setCurNavId", item.id);
      console.log(item.pc_url);
      this.$router.push(item.pc_url)
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/nav.js